<template>
  <div class="KnowledgePointReviewModal">
    <el-dialog
      title="知识点回顾"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
      width="30%"
    >
      <div class="content">
        <el-form ref="form" :model="formData" size="mini" label-width="auto">
          <el-form-item
            v-for="(item, index) in formData.contents"
            :key="index"
            :label="`知识点 ${index + 1}`"
          >
            <div class="textareaBox">
              <textarea v-model="item.content"></textarea>
            </div>
            <div class="iconBox">
              <div>
                <i
                  class="el-icon-circle-plus-outline"
                  @click="handleAdd(index)"
                ></i>
              </div>
              <div>
                <i
                  class="el-icon-remove-outline"
                  @click="handleDelete(item.id, index)"
                ></i>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button type="primary" @click="handleFinished">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { knowledgePointReviewMixins } from "@/pages/MyOutLine/knowledgePointReviewMixins";

export default {
  name: "KnowledgePointReviewModal",
  mixins: [knowledgePointReviewMixins],
  props: {
    lessonId: {
      type: Number,
      default: null,
    },
    version: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      knowledgePointReviewContentList: [],
    };
  },
  computed: {
    ...mapState("courseCenter", [
      "knowledgePointReviewModalVisible",
      "pointReviewContentList",
    ]),
    visible: {
      get() {
        return this.$store.state.courseCenter.knowledgePointReviewModalVisible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "knowledgePointReviewModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapActions("courseCenter", [
      "deletePointReviewContent",
      "getLessonPointReviewContentList",
    ]),
    contentLengthMethod() {
      return this.formData.contents.every((item) => item.content === "");
    },
    // 打开弹框
    handleOpen() {
      this.clearForm();
      if (this.pointReviewContentList.data.length < 1) {
        // this.formData.contents.push({ content: "" });
      } else {
        this.formData.contents = this.pointReviewContentList.data;
      }
    },
    // 新增
    handleAdd(index) {
      this.formData.contents.splice(index + 1, 0, { content: "" });
    },
    // 删除
    async handleDelete(id, index) {
      // if (!id) {
      this.formData.contents.splice(index, 1);
      if (this.pointReviewContentList.data.length < 1) {
        this.clearForm();
      } else {
        this.formData.contents = this.pointReviewContentList.data;
      }
      // }
      // this.$confirm("请确认是否要删除该条知识点？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(async () => {
      //     await this.deletePointReviewContent({
      //       id: id,
      //     });
      //     await this.getLessonPointReviewContentList({
      //       lessonId: this.lessonId,
      //       version: this.version,
      //     });
      //     if (this.pointReviewContentList.data.length < 1) {
      //       this.clearForm();
      //     } else {
      //       this.formData.contents = this.pointReviewContentList.data;
      //     }
      // })
      // .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.KnowledgePointReviewModal {
  position: relative;

  ::v-deep .el-dialog {
    min-width: 750px;
    height: 750px;
  }

  .content {
    height: 600px;
    padding-right: 10px;
    margin-bottom: 10px;
    overflow-y: auto;

    .textareaBox {
      display: inline-block;
      width: 95%;

      textarea {
        min-height: 150px !important;
        height: auto;
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border: 1px solid #ccc;
        resize: none;
        line-height: 1.5;
        font-family: inherit;
      }
    }

    .iconBox {
      display: inline-block;
      margin-left: 10px;

      .el-icon-remove-outline,
      .el-icon-circle-plus-outline {
        cursor: pointer;
        color: map-get($colors, primary);
      }
    }
  }

  .content::-webkit-scrollbar {
    width: 5px;
    height: 8px;
  }

  .content::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  .content::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 5px;
  }

  .footer {
    position: absolute;
    text-align: center;
    bottom: 20px;
    right: 50px;
    left: 50px;
  }
}
</style>
